export default __webpack_public_path__ + "images/JZ.bcbb7a9.png";